import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fireOperationalAnalytics } from '@atlassian/analytics-bridge';
import { Action, ActionSubject } from '@atlassian/proforma-utils/analytics';
import { DEFAULT_ORDER_DIRECTION, DEFAULT_ORDER_FIELD } from '../../constants';
import { deleteAttachmentRequest, fetchAttachmentsRequest, initialAttachmentState } from '../../utils';
export var setIsFetching = function setIsFetching(issueKey, isFetching) {
  return function (_ref) {
    var setState = _ref.setState,
      getState = _ref.getState;
    var oldState = getState();
    setState({
      // @ts-expect-error - TS2322 - Type '{ [x: string]: { isDownloading: boolean; isFetching: boolean; error: Error | null; totalCount: number | undefined; deletableCount: number | undefined; visibleAttachments: Attachment[]; } | { ...; } | { ...; } | undefined; }' is not assignable to type 'Partial<Record<string, { isDownloading: boolean; isFetching: boolean; error: Error | null; totalCount: number | undefined; deletableCount: number | undefined; visibleAttachments: Attachment[]; } | undefined>>'.
      issueAttachments: _objectSpread(_objectSpread({}, oldState.issueAttachments), {}, _defineProperty({}, issueKey, _objectSpread(_objectSpread({}, oldState.issueAttachments[issueKey] || initialAttachmentState), {}, {
        isFetching: isFetching
      })))
    });
  };
};
export var setError = function setError(issueKey, error) {
  return function (_ref2) {
    var setState = _ref2.setState,
      getState = _ref2.getState;
    var oldState = getState();
    setState({
      // @ts-expect-error - TS2322 - Type '{ [x: string]: { isDownloading: boolean; isFetching: boolean; error: Error | null; totalCount: number | undefined; deletableCount: number | undefined; visibleAttachments: Attachment[]; } | { ...; } | { ...; } | undefined; }' is not assignable to type 'Partial<Record<string, { isDownloading: boolean; isFetching: boolean; error: Error | null; totalCount: number | undefined; deletableCount: number | undefined; visibleAttachments: Attachment[]; } | undefined>>'.
      issueAttachments: _objectSpread(_objectSpread({}, oldState.issueAttachments), {}, _defineProperty({}, issueKey, _objectSpread(_objectSpread({}, oldState.issueAttachments[issueKey] || initialAttachmentState), {}, {
        error: error
      })))
    });
  };
};
export var setOrderDirection = function setOrderDirection(orderDirection) {
  return function (_ref3) {
    var getState = _ref3.getState,
      setState = _ref3.setState;
    var _getState = getState(),
      currentMeta = _getState.meta;
    setState({
      meta: _objectSpread(_objectSpread({}, currentMeta), {}, {
        orderDirection: orderDirection
      })
    });
  };
};
export var setOrderField = function setOrderField(orderField) {
  return function (_ref4) {
    var getState = _ref4.getState,
      setState = _ref4.setState;
    var _getState2 = getState(),
      currentMeta = _getState2.meta;
    setState({
      meta: _objectSpread(_objectSpread({}, currentMeta), {}, {
        orderField: orderField
      })
    });
  };
};
export var setTotalCount = function setTotalCount(issueKey, totalCount) {
  return function (_ref5) {
    var setState = _ref5.setState,
      getState = _ref5.getState;
    var oldState = getState();
    setState({
      // @ts-expect-error - TS2322 - Type '{ [x: string]: { isDownloading: boolean; isFetching: boolean; error: Error | null; totalCount: number | undefined; deletableCount: number | undefined; visibleAttachments: Attachment[]; } | { ...; } | { ...; } | undefined; }' is not assignable to type 'Partial<Record<string, { isDownloading: boolean; isFetching: boolean; error: Error | null; totalCount: number | undefined; deletableCount: number | undefined; visibleAttachments: Attachment[]; } | undefined>>'.
      issueAttachments: _objectSpread(_objectSpread({}, oldState.issueAttachments), {}, _defineProperty({}, issueKey, _objectSpread(_objectSpread({}, oldState.issueAttachments[issueKey] || initialAttachmentState), {}, {
        totalCount: totalCount
      })))
    });
  };
};
export var setDeletableCount = function setDeletableCount(issueKey, deletableCount) {
  return function (_ref6) {
    var setState = _ref6.setState,
      getState = _ref6.getState;
    var oldState = getState();
    setState({
      // @ts-expect-error - TS2322 - Type '{ [x: string]: { isDownloading: boolean; isFetching: boolean; error: Error | null; totalCount: number | undefined; deletableCount: number | undefined; visibleAttachments: Attachment[]; } | { ...; } | { ...; } | undefined; }' is not assignable to type 'Partial<Record<string, { isDownloading: boolean; isFetching: boolean; error: Error | null; totalCount: number | undefined; deletableCount: number | undefined; visibleAttachments: Attachment[]; } | undefined>>'.
      issueAttachments: _objectSpread(_objectSpread({}, oldState.issueAttachments), {}, _defineProperty({}, issueKey, _objectSpread(_objectSpread({}, oldState.issueAttachments[issueKey] || initialAttachmentState), {}, {
        deletableCount: deletableCount
      })))
    });
  };
};
export var setStartAt = function setStartAt(startAt) {
  return function (_ref7) {
    var getState = _ref7.getState,
      setState = _ref7.setState;
    var _getState3 = getState(),
      currentMeta = _getState3.meta;
    setState({
      meta: _objectSpread(_objectSpread({}, currentMeta), {}, {
        startAt: startAt
      })
    });
  };
};
export var setVisibleAttachments = function setVisibleAttachments(issueKey, visibleAttachments) {
  return function (_ref8) {
    var setState = _ref8.setState,
      getState = _ref8.getState;
    var oldState = getState();
    setState({
      issueAttachments: _objectSpread(_objectSpread({}, oldState.issueAttachments), {}, _defineProperty({}, issueKey, _objectSpread(_objectSpread({}, oldState.issueAttachments[issueKey] || initialAttachmentState), {}, {
        visibleAttachments: visibleAttachments
      })))
    });
  };
};
export var addNewAttachments = function addNewAttachments(issueKey, newAttachments) {
  return function (_ref9) {
    var setState = _ref9.setState,
      getState = _ref9.getState;
    var oldState = getState();
    var oldAttachments = oldState.issueAttachments[issueKey] ?
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    oldState.issueAttachments[issueKey].visibleAttachments : [];
    var oldTotalCount = oldState.issueAttachments[issueKey] ?
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    oldState.issueAttachments[issueKey].totalCount || 0 : 0;
    var allAttachments = newAttachments.concat(oldAttachments);
    var totalCount = oldTotalCount + newAttachments.length;
    setState({
      issueAttachments: _objectSpread(_objectSpread({}, oldState.issueAttachments), {}, _defineProperty({}, issueKey, _objectSpread(_objectSpread({}, oldState.issueAttachments[issueKey] || initialAttachmentState), {}, {
        visibleAttachments: allAttachments,
        totalCount: totalCount
      })))
    });
  };
};
export var getAttachments = function getAttachments(issueKey, createAnalyticsEvent, fetchOptions) {
  return /*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref0) {
      var dispatch, response, errorString;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch = _ref0.dispatch;
            dispatch(setIsFetching(issueKey, true));
            dispatch(setError(issueKey, null));
            _context.prev = 3;
            _context.next = 6;
            return fetchAttachmentsRequest(issueKey, fetchOptions);
          case 6:
            response = _context.sent;
            if (response) {
              dispatch(setTotalCount(issueKey, response.totalCount));
              typeof response.deletableCount === 'number' && dispatch(setDeletableCount(issueKey, response.deletableCount));
              dispatch(setVisibleAttachments(issueKey, response.nodes));

              // Set or reset pagination/sorting
              dispatch(setOrderDirection((fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.orderDirection) || DEFAULT_ORDER_DIRECTION));
              dispatch(setOrderField((fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.orderField) || DEFAULT_ORDER_FIELD));
              dispatch(setStartAt((fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.startAt) || 0));
              fireOperationalAnalytics(createAnalyticsEvent({}), "".concat(ActionSubject.FETCH_FORM_ATTACHMENTS, " ").concat(Action.UPDATED), {
                issueKey: issueKey,
                attachmentCount: response.nodes.length,
                totalCount: response.totalCount,
                deletableCount: response.deletableCount
              });
            } else {
              errorString = 'Failed to fetch issue attachments';
              dispatch(setError(issueKey, new Error(errorString)));
              // log.safeErrorWithoutCustomerData(
              //   'issue.attachments.fetch-attachments',
              //   errorString,
              // );
              fireOperationalAnalytics(createAnalyticsEvent({}), "".concat(ActionSubject.FETCH_FORM_ATTACHMENTS, " ").concat(Action.FAILED), {
                issueKey: issueKey,
                error: 'Failed to fetch issue attachments'
              });
            }
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            dispatch(setError(issueKey, _context.t0));
            // log.safeErrorWithoutCustomerData(
            //   'issue.attachments.fetch-attachments',
            //   e.toString(),
            // );
            fireOperationalAnalytics(createAnalyticsEvent({}), "".concat(ActionSubject.FETCH_FORM_ATTACHMENTS, " ").concat(Action.FAILED), {
              issueKey: issueKey,
              error: _context.t0
            });
          case 14:
            dispatch(setIsFetching(issueKey, false));
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 10]]);
    }));
    return function (_x) {
      return _ref1.apply(this, arguments);
    };
  }();
};
export var deleteAttachment = function deleteAttachment(issueKey, deletingAttachmentId, createAnalyticsEvent, fetchOptions) {
  return /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref10) {
      var dispatch, getState, state, issueAttachments, totalCount, visibleAttachments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch = _ref10.dispatch, getState = _ref10.getState;
            state = getState();
            issueAttachments = state.issueAttachments[issueKey];
            if (issueAttachments) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return");
          case 5:
            totalCount = issueAttachments.totalCount, visibleAttachments = issueAttachments.visibleAttachments;
            if (!(totalCount !== undefined)) {
              _context2.next = 19;
              break;
            }
            dispatch(setVisibleAttachments(issueKey, visibleAttachments.filter(function (attachment) {
              return attachment.id !== deletingAttachmentId;
            })));
            dispatch(setTotalCount(issueKey, totalCount - 1));
            _context2.prev = 9;
            _context2.next = 12;
            return deleteAttachmentRequest(deletingAttachmentId);
          case 12:
            dispatch(getAttachments(issueKey, createAnalyticsEvent, fetchOptions));
            _context2.next = 19;
            break;
          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](9);
            dispatch(getAttachments(issueKey, createAnalyticsEvent, fetchOptions));
            throw _context2.t0;
          case 19:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[9, 15]]);
    }));
    return function (_x2) {
      return _ref11.apply(this, arguments);
    };
  }();
};
export var refreshAttachments = function refreshAttachments(issueKey, createAnalyticsEvent, fetchOptions) {
  return function (_ref12) {
    var dispatch = _ref12.dispatch,
      getState = _ref12.getState;
    var state = getState();
    var issueAttachments = state.issueAttachments[issueKey];
    if (!issueAttachments) {
      return;
    }
    var startAt = state.meta.startAt;
    var isFetching = issueAttachments.isFetching;
    if (!isFetching || fetchOptions && fetchOptions.startAt !== startAt) {
      dispatch(getAttachments(issueKey, createAnalyticsEvent, fetchOptions));
    }
  };
};